// extracted by mini-css-extract-plugin
export default {"browser__support-error":"BrowserSupport-module__browser__support-error___byKag"};